export const SUPPLIER_QUESTIONNAIRES = {
  BACKOFFICE_PATH: '/backoffice/supplier-questionnaires',
  MODEL_SECRET: 'SUPPLIER_QUESTIONNAIRE_MODEL_ARN',
  PROMPTS: {
    SUPPLIER_QUESTIONNAIRE: 'supplier-questionnaire.txt',
    ORCHESTRATION: 'supplier-questionnaire-orchestration.txt',
  },
  INFERENCE: {
    NUMBER_OF_RESULTS: 10,
    TEMPERATURE: 0.1, // More precise answers, less creative
    MAX_TOKENS: 1000,
  },
} as const

export const QUESTIONNAIRE_PACKAGE_STATUS = {
  PENDING: 'PENDING' as const,
  BUILDING: 'BUILDING' as const,
  READY: 'READY' as const,
  FAILED: 'FAILED' as const,
}

export type IQuestionnairePackageStatus =
  (typeof QUESTIONNAIRE_PACKAGE_STATUS)[keyof typeof QUESTIONNAIRE_PACKAGE_STATUS]

export const QUESTIONNAIRE_SOURCE_KIND = {
  PLATFORM_DOCUMENT: 'platform_document' as const,
  CONTEXT_DOCUMENT: 'context_document' as const,
  UNKNOWN: 'unknown' as const,
}

export type IQuestionnaireSourceKind = (typeof QUESTIONNAIRE_SOURCE_KIND)[keyof typeof QUESTIONNAIRE_SOURCE_KIND]

export const QUESTIONNAIRE_SOURCE_STATUS = {
  PENDING: 'PENDING' as const,
  SAVED: 'SAVED' as const,
  FAILED: 'FAILED' as const,
}

export type IQuestionnaireSourceStatus = (typeof QUESTIONNAIRE_SOURCE_STATUS)[keyof typeof QUESTIONNAIRE_SOURCE_STATUS]

export const SUPPLIER_QUESTIONNAIRES_ROUTE = '/suppliers/questionnaires'

export const PLACEHOLDER_FILE_PATH = '__pending__'
